module.exports = __webpack_public_path__ + "img/calendar.d487cf2d.png";